export default __webpack_public_path__ + "0a94690a3506cb8abded8f9017fdbd76.png";